import React from 'react';
import { Redirect } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import { usePermissoes } from '../context/PermissoesContext';

// Quem não tem a permissão da tela volta ao painel.
const SemAcesso = () => <Redirect to="/principal" />;

/**
 * A PrivateRoute de uma tela restrita (`ROTAS_RESTRITAS` do routes.js): as regras dela valem como estão (login,
 * perfil, tela do cargo) e, passando por elas, a tela só abre para quem tem uma regra que a abra (o admin abre
 * todas). O `nome` e o `grupo` da tela ficam aqui: são só da lista da tela de Permissões de Acesso.
 * Antes da primeira leitura das permissões (nada guardado neste navegador: login de antes do deploy, link de e-mail),
 * espera em vez de fechar a tela de quem tem a permissão.
 */
export default function RestrictedRoute({ component, nome, grupo, ...props }) {
    const permissoes = usePermissoes();
    if (!permissoes.carregadas) return null;
    return <PrivateRoute {...props} component={permissoes.temAcesso(props.path) ? component : SemAcesso} />;
}
